// extracted by mini-css-extract-plugin
export default {"DefaultAvatar":"styles_DefaultAvatar__qXNE0"};